import { NgModule } from '@angular/core';
import { EmpusaMicroApp, EmpusaMicroAppType } from '@empusa/empusa-core';
import { ManagersAgreementsHomeModule } from './managers-agreements.home.module';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
})
export class ManagersAgreementsModule implements EmpusaMicroApp {
  name: string = 'managers-agreements';
  description: string = 'Acuerdo con gestores';
  icon: string = 'managers-agreements';
  page: any = ManagersAgreementsHomeModule;
  homeApp: boolean = false;
  path: string = 'managers-agreements';
  order: number = 10;
  resourceServerId: string = "keycloak-auth-manager-resources-server";
  appType: EmpusaMicroAppType = EmpusaMicroAppType.home;

  constructor() {
    //we register ourselves
    (<any>window).empusa(this);
    console.debug('Load microapp ', this.name);
  }
}
